import React from 'react';
import { theme } from 'lib/style';
import { PrimaryButton } from 'lib/components';
import styled from 'styled-components/macro';

type Props = {
  icon?: JSX.Element;
  textColor?: string;
  backgroundColor?: string;
  border?: string;
  hoverBorder?: string;
  margin?: string;
  text?: string;
  height?: string;
  textPadding?: string;
  iconPadding?: string;
  fontSize?: number;
  disabled?: boolean;
  iconPlacement?: 'left' | 'right';
  width?: number;
  iconMargin?: string;
  onClick(): void;
  showTooltipOnClick?: boolean;
  tooltipTitle?: string;
  tooltipMessage?: string;
};

const ContentWrapper = styled.div`
  padding: 10px;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipContent = styled.div`
  position: absolute;
  width: 250px;
  top: 100%;
  left: 10%;
  transform: translateX(-50%);
  border-radius: 4px;
  background-color: ${theme.palette.white};
  box-shadow: 0 8px 32px 0 rgba(29, 30, 36, 0.08);
  border: solid 1px rgb(247, 248, 250);
  padding: 5px;
  font-size: 14px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease-in-out;

  & ul {
    list-style-type: disc;
    padding-left: 20px;
    margin: 0;
  }

  & li {
    margin: 5px 0;
  }
`;

const TooltipTrigger = styled.div<{ showTooltip?: boolean }>`
  display: inline-block;
  cursor: pointer;

  ${({ showTooltip }) =>
    showTooltip
      ? ` &:hover + ${TooltipContent} {
    opacity: 1;
    visibility: visible;
  }`
      : ''}
`;

const Title = styled.h3`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  margin: 0;
  width: 100%;
  max-width: 200px;
  line-height: 24px;
`;

const Message = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  width: 100%;
  max-width: 200px;
  line-height: 24px;
`;

export const ActionButtonWithTooltip = ({
  icon,
  iconPlacement = 'left',
  textColor = theme.palette.gray100,
  backgroundColor = theme.palette.gray20,
  margin = '0 0 0 8px',
  textPadding = '8px 16px',
  iconPadding = '8px 0px 8px 12px',
  height = '40px',
  fontSize = 15,
  text = '',
  disabled = false,
  width,
  iconMargin,
  border,
  hoverBorder,
  onClick = () => {},
  showTooltipOnClick = false,
  tooltipTitle,
  tooltipMessage,
}: Props) => {
  return (
    <TooltipWrapper>
      <TooltipTrigger showTooltip={showTooltipOnClick}>
        <PrimaryButton
          height={height}
          text={text}
          margin={margin}
          borderRadius={5}
          textColor={textColor}
          backgroundColor={backgroundColor}
          fontSize={fontSize}
          textPadding={textPadding}
          icon={icon}
          iconPadding={iconPadding}
          onClick={!showTooltipOnClick ? onClick : undefined}
          disabled={disabled}
          center={true}
          iconPlacement={iconPlacement}
          width={width}
          iconMargin={iconMargin}
          border={border}
          hoverBorder={hoverBorder}
        />
      </TooltipTrigger>
      <TooltipContent>
        <ContentWrapper>
          <Title>{tooltipTitle}</Title>
          <Message>{tooltipMessage}</Message>
        </ContentWrapper>
      </TooltipContent>
    </TooltipWrapper>
  );
};
